import ErrorOutlineRoundedIcon from "@mui/icons-material/ErrorOutlineRounded";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { useAnalytics } from "@/contexts/analytics/hooks";
import { EmptyState, EmptyStateSize } from "@/ui/molecules/EmptyState";
import SystemButton from "@/ui/SystemButton/SystemButton";

/** What the content area shows when the routed page throws or its code fails to download. */
export const PageLoadError: FC = () => {
	const { t } = useTranslation();
	const { track } = useAnalytics();

	return (
		<EmptyState
			icon={<ErrorOutlineRoundedIcon />}
			size={EmptyStateSize.Page}
			titleComponent="h1"
			title={t("page.load.failed.title")}
			hint={t("page.load.failed.hint")}
			action={
				<SystemButton
					data-testid="page-load-error-refresh-button"
					onClick={() => {
						track("page_load_error_refresh");
						window.location.reload();
					}}
				>
					{t("Refresh")}
				</SystemButton>
			}
			dataTestId="page-load-error"
		/>
	);
};
